import { render } from "./CategorySelector.vue?vue&type=template&id=c472d0ec"
import script from "./CategorySelector.vue?vue&type=script&lang=js"
export * from "./CategorySelector.vue?vue&type=script&lang=js"

import "./CategorySelector.vue?vue&type=style&index=0&id=c472d0ec&lang=scss"
script.render = render

export default script